import React from "react";
import styled from "styled-components";
import Section from "./Section";
import "./css/Home.css";
import Header from "./Header";

function Home() {
  return (
    <>
      <Header />
      <Section
        title="Model S"
        description="Order Online for Touchless Delivery"
        leftbtn="custom order"
        rightbtn={"existing Inventory"}
        backgroundImg="model-s.jpg"
      />
      <Section
        title="Model Y"
        description="Order Online for Touchless Delivery"
        leftbtn="custom order"
        rightbtn={"existing Inventory"}
        backgroundImg="model-y.jpg"
      />
      <Section
        title="Model 3"
        description="Order Online for Touchless Delivery"
        leftbtn="custom order"
        rightbtn={"existing Inventory"}
        backgroundImg="model-3.jpg"
      />
      <Section
        title="Model X"
        description="Order Online for Touchless Delivery"
        leftbtn="custom order"
        rightbtn={"existing Inventory"}
        backgroundImg="model-x.jpg"
      />
      <Section
        title="Lowest Cost Solar Panels in America"
        description="Money-back guarantee"
        leftbtn="order now"
        rightbtn={"learn-more"}
        backgroundImg="solar-panel.jpg"
      />
      <Section
        title="Solar for New Roofs"
        description="solar Roof Costs Less Than a New Roof Solar Panels"
        leftbtn="learn-more"
        rightbtn={"learn more"}
        backgroundImg="solar-roof.jpg"
      />
      <Section
        classname="access"
        title="Accessories"
        // description="Order Online for Touchless Delivery"
        leftbtn="Shop now"
        // rightbtn={"existing Inventory"}
        backgroundImg="accessories.jpg"
      />
    </>
  );
}

export default Home;
